import { select, call, put, takeEvery, takeLatest, delay, all } from 'redux-saga/effects';

//import * as $ from 'jquery';

/**
 * 
 * 3-2 setting base Mysaga func
 * 
 */
function* AjaxGetPost(arr: any) {
    /**
     * ajax func
     * 
     * https://column.yamato-gp.net/get_json.php?limit=3
     * 
     */
    //console.log("utl2 is ",arr.url);
    const retvalue = yield call(() => {
        try {
            
            //const bookid = $("#bots_ajax").data("bookid");

            return fetch(arr.url)
                .then(res => res.json())
                .then(json => {
                    console.log("json is ",json[0]);
                    return { allPage: json[0].allPage, count: json[0].allPost , data: json[0].datas }
                    //return { count: html.length, data: html }
                })
        } catch (e) {
            return { count: "0" }
        }
    });
    yield put({ type: "ajax_get_post", volume: retvalue });
}

function* TestClick(v: any) {
    yield put({ type: "test", volume: v })
}

/**
 * 3-2 setting Mysaga
 */
function* MySaga() {
    yield all([
        takeLatest("Ajax_Get_Post", AjaxGetPost),
        takeLatest("Test_Click", TestClick),
    ]);
}

export default MySaga;
